import { render, staticRenderFns } from "./ghost.vue?vue&type=template&id=7c230dbb"
import script from "./ghost.vue?vue&type=script&lang=js"
export * from "./ghost.vue?vue&type=script&lang=js"
import style0 from "./ghost.vue?vue&type=style&index=0&id=7c230dbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports